import {
    DELETE_COUNTRY_MAPPING_SUCCESS,
    DELETE_COUNTRY_MAPPING_FAILED,
    LOADING_DELETE_COUNTRY_MAPPING,
    RESET_DELETE_COUNTRY_MAPPING,
    NETWORK_ERROR_DELETE_COUNTRY_MAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetDeleteCountryMapping = () => {
    return { type: RESET_DELETE_COUNTRY_MAPPING };
};

const adminDeleteCountryMapping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETE_COUNTRY_MAPPING });
    await adminServices
        .post("deleteCountryMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: DELETE_COUNTRY_MAPPING_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: DELETE_COUNTRY_MAPPING_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DELETE_COUNTRY_MAPPING,
                payload: err
            });
        });
};

export { adminDeleteCountryMapping, resetDeleteCountryMapping }